import { environment } from '../../environments/environment';

export const STRIPE_KEY = environment.stripeKey;
export const API_DOMAIN = environment.domain;
export const MAIN_DOMAIN = environment.mainDomain;
export const API_VERSION = 'v1';
